import { qualidadeCta } from "@/mocks/cta";

const metricas = [
  { label: "Coordenada válida", pct: qualidadeCta.coordenadaValida, color: "bg-primary-500" },
  { label: "Com foto", pct: qualidadeCta.comFoto, color: "bg-accent-500" },
  { label: "Espécie identificada", pct: qualidadeCta.especieIdentificada, color: "bg-primary-500" },
  { label: "Vistoria validada", pct: qualidadeCta.vistoriaValidada, color: "bg-accent-500" },
  { label: "Responsável técnico", pct: qualidadeCta.responsavelTecnico, color: "bg-primary-400" },
];

export default function TreeQualityPanel() {
  return (
    <div className="bg-white rounded-card border border-background-200 p-5">
      <div className="flex items-center gap-2 mb-4">
        <div className="w-8 h-8 rounded-lg bg-accent-100 flex items-center justify-center">
          <i className="ri-shield-check-line text-accent-600 text-sm"></i>
        </div>
        <h3 className="text-sm font-semibold text-foreground-900 font-heading">Qualidade do Cadastro</h3>
      </div>
      <div className="space-y-3">
        {metricas.map((m) => (
          <div key={m.label}>
            <div className="flex items-center justify-between mb-1">
              <span className="text-xs text-foreground-600">{m.label}</span>
              <span className="text-xs font-semibold text-foreground-900 tabular-nums">{m.pct}%</span>
            </div>
            <div className="h-1.5 rounded-full bg-background-200 overflow-hidden">
              <div
                className={`h-full rounded-full ${m.color} transition-all duration-300`}
                style={{ width: `${m.pct}%` }}
                role="progressbar"
                aria-valuenow={m.pct}
                aria-valuemin={0}
                aria-valuemax={100}
                aria-label={`${m.label}: ${m.pct}%`}
              ></div>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-4 pt-3 border-t border-background-200">
        <div className="flex items-center justify-between">
          <span className="text-xs text-foreground-500">Índice de Qualidade Geral</span>
          <span className="text-sm font-bold text-primary-700 font-heading">
            {Math.round(Object.values(qualidadeCta).reduce((a, b) => a + b, 0) / 5)}%
          </span>
        </div>
      </div>
    </div>
  );
}